// useOutsideClickClose.ts
import { onBeforeUnmount, type Ref, watch } from 'vue';

type Deps = {
  enabled: Ref<boolean>;
  rootEl: Ref<HTMLElement | null>;
  onOutside: () => void;
};

export function useOutsideClickClose(deps: Deps) {
  const { enabled, rootEl, onOutside } = deps;

  function handler(event: MouseEvent) {
    const root = rootEl.value;
    if (!root) return;

    const path = event.composedPath?.() ?? [];
    const clickedInside = path.includes(root);
    if (!clickedInside) onOutside();
  }

  watch(
    enabled,
    (on) => {
      if (on) document.addEventListener('click', handler);
      else document.removeEventListener('click', handler);
    },
    { immediate: true },
  );

  onBeforeUnmount(() => {
    document.removeEventListener('click', handler);
  });
}
